var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-switch-wrapper" },
    _vm._l(_vm.options, function (option) {
      return _c(
        "span",
        {
          key: option.value,
          staticClass: "option",
          class: {
            selected: _setup._model == option.value,
            disabled: option.disabled,
          },
          attrs: { role: "radio" },
          on: {
            click: function ($event) {
              return _setup.onOptionSelected(option)
            },
          },
        },
        [_vm._v("\n        " + _vm._s(option.label) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }